var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[(!_vm.showMaisInfs)?_c('a',{attrs:{"href":"#/usuarios"},on:{"click":_vm.maisInfs}},[_vm._v("Mais Infs.")]):_c('p',[_vm._v("\n       "+_vm._s(_vm.numPacientes)+" Pacientes (Incluindo os excluídos)\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }